export default __webpack_public_path__ + "static/media/heart_green.d9e3f296.svg";